import { AfterViewInit, DestroyRef, Directive, ElementRef, inject, OnDestroy, OnInit } from '@angular/core';
import { ImageDrawService } from '../../services/image-draw.service';
import { combineLatestWith, of, Subject, takeUntil, tap, withLatestFrom } from 'rxjs';
import {  Store } from '@ngrx/store';
import { BaseState } from '../../reducers';
import { selectLayerOrder, selectLayers } from '../store/editor.selector';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Directive({
  selector: '[appCanvas]',
  standalone: true,
})
export class CanvasDirective {
  imageDrawService = inject(ImageDrawService)
  destroyRef = inject(DestroyRef)

  constructor(private elRef: ElementRef<HTMLCanvasElement>, private drawService: ImageDrawService) {
    this.imageDrawService.previewImageUpdateStream$.pipe(
      takeUntilDestroyed(this.destroyRef)
    ).subscribe((editorState) => {
        this.imageDrawService.updatePreviewImage(elRef.nativeElement)
    })
  }
}
